import React from 'react';
import { UrgencyBar } from './components/UrgencyBar';
import { Hero } from './components/Hero';
import { IdentificationSection } from './components/IdentificationSection';
import { PilaresSection } from './components/PilaresSection';
import { TomosSection } from './components/TomosSection';
import { ComoEmpiezasSection } from './components/ComoEmpiezasSection';
import { BonusSection } from './components/BonusSection';
import { SituacionesSection } from './components/SituacionesSection';
import { ParaTiSection } from './components/ParaTiSection';
import { PriceSection } from './components/PriceSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full min-h-full bg-white font-sans text-gray-900" data-id="element-0" data-mp="23utbk3a460as">
      <UrgencyBar data-id="element-1" data-mp="3ikqytzf4l45q" />
      <main data-id="element-2" data-mp="3ij61y35c994p">
        <Hero data-id="element-3" data-mp="3ijpc2xoqyt86" />
        <IdentificationSection data-id="element-4" data-mp="3ii4t85bsoyq5" />
        <PilaresSection data-id="element-5" data-mp="3ml1397n9rmih" />
        <TomosSection data-id="element-6" data-mp="3mk8710lxsfel" />
        <ComoEmpiezasSection data-id="element-7" data-mp="3mjq3rk0ux0x6" />
        <BonusSection data-id="element-8" data-mp="3rc9hqi3ghy2i" />
        <SituacionesSection data-id="element-9" data-mp="3rbzlwdvqcwow" />
        <ParaTiSection data-id="element-10" data-mp="3rcsw5otwe4bs" />
        <PriceSection data-id="element-11" data-mp="3reltuemj9e7n" />
        <GuaranteeSection data-id="element-12" data-mp="5orh0l86u6j" />
        <FaqSection data-id="element-13" data-mp="4wxfu7a14id" />
        <FinalCtaSection data-id="element-14" data-mp="5ggxfcks0yi" />
      </main>
      <Footer data-id="element-15" data-mp="2zl3cjn8vpa6d" />
    </div>;
}